export const projects = [
  {
    id: 0,
    title: "Portfolio Website",
    img: ["/img/projects/portfolio.jpg", "/img/projects/portfolio_2.jpg", "/img/projects/portfolio_3.jpg"],
    lang: "React.js, Node.js, HTML, CSS",
    git: "https://github.com/akim-ruslanov/e-shop",
    demo: true,
    demo_link: "https://akim-ruslanov.netlify.app/",
    info:
      "This whole website was actually built from scratch by me. The reason I wanted one is to showcase all the projects I have been working on for the past few years. \nThis project was built on React.js using create-react-app. Some extra add-ons that I also ended up using were styled-component and react-router. Styled components allowed me to quickly add css without making global changes, and react-router allowed for quick and easy re-routing.",
  },
    {
      id: 1,
      title: "E-store",
      img: ["/img/projects/e-store.jpg", "/img/projects/e-store_2.jpg", "/img/projects/e-store_3.jpg"],
      lang: "React.js, HTML, CSS",
    git: "https://github.com/akim-ruslanov/e-shop",
    demo: true,
    demo_link: "https://eshop-akimchi.netlify.app/",
    info:
        "This was my first attempt at creating a user oriented react app. It was a great a project that taught me the basics of components, hooks and states. I also got to practice the use of Context API. Overall it was a good starter project which I will try to review after more time with React",
    },
    {
      id: 2,
      title: "TODO web app",
      img: ["/img/projects/todo.png", "/img/projects/todo_2.jpg","/img/projects/todo_3.jpg"],
      lang: "Flask, Python, sqlalchemy, HTML, CSS",
    git: "https://github.com/akim-ruslanov/todo_flask",
    demo: false,
    info:
        "I wanted to create an app that was specifially for TODO lists around coding. I noticed that whenever I work on multiple projects, I forget what methods I needed to work on, what tests were done and what functunality I needed to research. Hence, I created a very specific TODO web page which allows for creating TODO lists based on different projects. Furthermore, I wanted to set due dates which would be the indexes for priority queue. \nThe reason I went with Flask was because of its versatility and quickness. Setting up an app using Flask was an extremely quick task. Moreover, the documentation was easily accessible and the community seemed to have made a lot of examples which I incorporated in my own app.",
    },
    {
      id: 3,
      title: "University Resources Web Page",
      img: ["/img/projects/uni.jpg", "/img/projects/uni_2.jpg", "/img/projects/uni_3.jpg", "/img/projects/uni_4.jpg"],
      lang: "JavaScript, TypeScript, REST API,  SQL, Promises, Mocha Tests",
      demo: false,
    git: "https://github.com/akim-ruslanov/university_query_project",
    info: "This project was created as part of CPSC310 at UBC. The project was completed in collaboration with Esteban Margaron. \nThe prject was built using technologies such as Yarn, JSZip, parse5. REST API was implemented through TypeScript. Majority of the project was done using TypeScript and JavaScript. Testing was implemented using Mocha Test Environment with Chai Expectations. \n Some extra libraries that were used in this project include jszip and parse5. jszip helped with quick access to zip files which were later processed through our back-end. parse5 was used for web scraping all of the information about buildings."
    },
    {
      id: 4,
      title: "Conway's Game of Life",
      img: ["/img/projects/game-of-life.jpg", "/img/projects/game-of-life_1.jpg"],
      lang: "React.js, HTML, CSS",
      demo: true,
      demo_link: "https://akimchi-game-of-life.netlify.app/",
    git: "https://github.com/akim-ruslanov/game-of-life",
    info: "This was one of the 'one day projects'. It was fun and quick to implement. Plus, it allowed me to again look into the great community of Game of Life and find bunch great art that was done by incredible people."
    },
    {
      id: 5,
      title: "Pathfinding Algorithms",
      img: ["/img/projects/path-finding.jpg"],
      lang: "Python, PyGame, OOP",
      demo: false,
    git: "https://github.com/akim-ruslanov/path_finding",
    info: "I was too lazy to write project description. Just check out github page. Changes coming soon!"
    },
    {
      id: 6,
      title: "Web Resume",
      img: ["/img/projects/resume.jpg", "/img/projects/resume_2.jpg"],
      lang: "jQuery, HTML, CSS",
      demo: true,
      demo_link: "https://akim-ruslanov.github.io/resume_web/",
    git: "https://github.com/akim-ruslanov/resume_web",
    info: "I was too lazy to write project description. Just check out github page. Changes coming soon!"
    },
    {
      id: 7,
      title: "Web Scraping",
      img: ["/img/projects/web-scraping.jpg"],
      lang: "JavaScript, TypeScript, SQL",
      demo: false,
    git: "https://github.com/akim-ruslanov/resume/tree/master/python%20scripts",
    info: "I was too lazy to write project description. Just check out github page. Changes coming soon!"
    },
    {
      id: 8,
      title: "2048",
      img: ["/img/projects/2048.jpg"],
      lang: "Java, Swing, JUnit",
      demo: false,
    git: "https://github.com/akim-ruslanov/2048",
    info: "I was too lazy to write project description. Just check out github page. Changes coming soon!"
    },
  ];
  
  export const detailProject =     {
    id: 3,
    title: "Uni resource",
    img: "img/projects/uni.jpg",
    lang: "JavaScript, TypeScript, SQL",
    info:
      "University resources staroeh",
  };
  
